export default __webpack_public_path__ + "fonts/SuisseWorks-RegularItalic-WebXL.woff2";